<template>
  <div class="insights bg-white-1 shadow3 q-pa-lg">
    <template v-if="layout">
      <ChartSection
        :definition="mainDefinition"
        :initial-definition="mainInitialDefinition"
        :available-elements="mainAvailableElements"
        :context="mainContext"
        :set-definition="setMainDefinition"
      />

      <RenewalOverview />

      <ChartSection
        :definition="secDefinition"
        :initial-definition="secInitialDefinition"
        :available-elements="secAvailableElements"
        :context="secContext"
        :set-definition="setSecDefinition"
      />
      <Table />
    </template>

    <Grid v-else place-items="center" class="q-pa-xl">
      <q-spinner color="primary" size="2rem" />
    </Grid>
  </div>
</template>

<script>
import FinancialInsightsModule from './vuex/FinancialInsights'
// Libraries
import { mapState, mapGetters, mapMutations, mapActions } from 'vuex'
// Components
import ChartSection from './components/ChartSection'
import RenewalOverview from './components/RenewalOverview'
import Table from './components/Table'

export default {
  components: {
    ChartSection,
    RenewalOverview,
    Table
  },

  computed: {
    ...mapState('financial-insights', ['mainDefinition', 'secDefinition']),
    ...mapGetters('financial-insights', [
      'mainAvailableElements',
      'mainInitialDefinition',
      'mainContext',
      'secAvailableElements',
      'secInitialDefinition',
      'secContext',
      'layout'
    ])
  },

  beforeCreate() {
    this.$store.registerModule('financial-insights', FinancialInsightsModule)
  },

  beforeDestroy() {
    this.resetState()
    this.$store.unregisterModule('financial-insights')
  },

  created() {
    this.$store.dispatch('widgets/getContext')
    this.getAndSetFinancialPeriods()
  },

  methods: {
    ...mapMutations('financial-insights', ['resetState', 'setMainDefinition', 'setSecDefinition']),
    ...mapActions('financial-insights', ['getAndSetFinancialPeriods'])
  }
}
</script>

<style lang="stylus" scoped>
.insights {
  display grid
  gap 15px
  padding-bottom 15px
}
</style>

<style lang="stylus">
#app {
  min-width 0 !important
}
</style>
